import BApp from "../../Modules/BApp";
import BForm from "../../Modules/BForm";
import BRequest from "../../Modules/BRequest";
import BMeasurements from "./BMeasurements";

export default class BMeasurementsForm
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-measurements-form`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("submit", event => {
			if (event.target.matches(this.selector())) {
				event.preventDefault();

				const measurementsForm = new this(event.target.closest(this.selector()));
				measurementsForm.submit();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()} [type="submit"]`)) {
				event.preventDefault();

				const measurementsForm = new this(event.target.closest(this.selector()));
				measurementsForm.submit();
			}
		});
	}

	submit()
	{
		const form = new BForm(this.el);

		let timeMeasured = form.el.dataset?.date;
		if (!timeMeasured) {
			timeMeasured = form.el.querySelector(`[name="timeMeasured"]`).value;
		}

		form.resetErrors();
		form.disable();

		let data = {
			domain: form.el.dataset.domain,
			measurements: [],
			timeMeasured: timeMeasured,
		};

		try {
			data.page = new BMeasurements(form.el.closest(BMeasurements.selector())).getPage();
		} catch (error) {
			// Nevermind.
		}

		form.el.querySelectorAll(`[data-kind]`).forEach(el => {
			let value = el.value.trim();
			if (value.length) {
				data.measurements.push({
					kind: el.dataset.kind,
					value: value,
				});
			}
		});

		BRequest.call(form.getMethod(), form.getURL(), data).then(response => {
			try {
				new BMeasurements(document.querySelector(BMeasurements.selector())).setFromResponse(response);
			} catch (error) {
				// Nevermind.
			}

			form.el.reset();
			try {
				form.el.closest(`dialog`).close();
			} catch (error) {
				// Nevermind.
			}
		}).catch(error => {
			form.setErrorResponse(error.response);
		}).finally(() => {
			form.enable();
			BApp.refresh();
		})
	}
}
